export default "__VITE_ASSET__BtkJ33R9__"